import { getHubByKey, getHubByRoutingHub } from './hubs';
import { DEFAULT_LANG } from 'constants/language';

const getHubLanguages = (userHub, routingHub) => {
  const hub = userHub ? getHubByKey(userHub) : getHubByRoutingHub(routingHub);
  if (hub) {
    return hub.AVAILABLE_LANGUAGES;
  }
  return [DEFAULT_LANG];
};

export default getHubLanguages;
